module.exports = {"630203100":"平安镇","630203101":"小峡镇","630203102":"三合镇","630203200":"洪水泉乡","630203201":"石灰窑乡","630203202":"古城乡","630203203":"沙沟乡","630203204":"巴藏沟乡","630203400":"曹家堡临空综合经济园平安园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/630203.json
// module id = 2774
// module chunks = 0